import { api, Auth } from "@services";

export const send_Message = (form) => {
  const userRole = (Auth.role == "agent" ? "agent" : "company");
  return api.post(`/v1/${userRole}/leads/sendemail`, form);
};
